import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { yellowish } from '../assets/colors';
import { Box, Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

export default function CustomRadioButton(props) {
  let itemList = props?.list ? props?.list : []
  if( itemList?.length === 0){
    itemList = [{value: props?.value1, label: props?.label}, {value: props?.value2, label: props?.labe2}]
  }
  return (
    <FormControl>
      {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
      <RadioGroup
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={props?.value}
        onChange={(e) => {
          props.updateFunc(e.target.value)}}
        sx={{
            '& .MuiSvgIcon-root': {
              fontSize: '1rem',
            //   color: yellowish
            },
          }}
      >
        {itemList?.map((ele, index) => (
          <Box style ={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
            <FormControlLabel value={ele.value} control={<Radio />} label={ele.label} />
            {props?.infoRequired && 
              <>
                <Box sx={{ display: 'flex', alignItems: 'center'}}>
                  <Tooltip title = {ele?.info} placement='right'>
                    <InfoOutlined></InfoOutlined>
                  </Tooltip>
                </Box>
              </>
            }
          </Box>
          
        ))}
        
        
        {/* <FormControlLabel value={props.value2} control={<Radio />} label={props.label2} /> */}
        {/* <FormControlLabel value="other" control={<Radio />} label="Other" /> */}
        {/* <FormControlLabel
          value="disabled"
          disabled
          control={<Radio />}
          label="other"
        /> */}
      </RadioGroup>
    </FormControl>
  );
}